export * as headingStyleConfigs from './style-configs';
export { Heading } from './heading';
export type { HeadingProps } from './types';
